<template>
    <div class="proposeList">
        <!-- <div class="header">
            <img src="@/assets/new/fan.png"  @click="goHome" alt="">
            <span>我的奖励</span>
        </div> -->
        <div class="gone" style="margin-bottom: 30px">
            <img src="@/assets/c/dlogo.png" class="dlogo" alt="" />
            <span class="gname" style="margin-left: 10px">Galmcypro</span>
        </div>
        <!-- <div class="gtwo">
            <div class="gleft">
                <img src="@/assets/c/img_tb.png" class="img_tb" alt="">
                <span class="gmiao">{{ $t('new.yzhi') }}</span>
            </div>
            <div class="gright">
                <img src="@/assets/c/icon_ss.png" class="icon_ss" alt="">
            </div>
        </div> -->

        <div
            class="gnlist animate__animated animate__bounceInRight"
            @click="getDetail(item.id)"
            v-for="(item, index) in list"
            :key="index"
        >
            <div class="gntit">
                <img
                    src="@/assets/c/biconthree.png"
                    class="biconthree"
                    alt=""
                />
                <span class="gbt">{{ item.title }}</span>
            </div>
            <div class="gnnav">
                <span class="ntit">{{ item.synopsis }}</span>
                <div class="ncha">
                    <img src="@/assets/c/icon_sj.png" class="icon_sj" alt="" />
                    <span class="chatime">{{ item.created_at }}</span>
                    <span class="cname">{{ $t("new.cha") }}></span>
                </div>
            </div>
        </div>

        <!--        <div class="gnlist" @click="getDetail">-->
        <!--            <div class="gntit">-->
        <!--                <img src="@/assets/c/biconthree.png" class="biconthree" alt="">-->
        <!--                <span class="gbt">Galmcypro {{ $t('new.bt') }}</span>-->
        <!--            </div>-->
        <!--            <div class="gnnav">-->
        <!--                <span class="ntit">{{ $t('new.baomiao') }}</span>-->
        <!--                <div class="ncha">-->
        <!--                    <img src="@/assets/c/icon_sj.png" class="icon_sj" alt="">-->
        <!--                    <span class="chatime">2024.09.20 14:25:19</span>-->
        <!--                    <span class="cname">{{ $t('new.cha') }}></span>-->
        <!--                </div>-->
        <!--            </div>-->
        <!--        </div>-->
        <div class="fanview" @click="handleBack">
            <img src="@/assets/c/fan.png" class="bg" alt="" />
        </div>
    </div>
</template>

<script>
import { ajaxData } from "@/api/ajax";

export default {
    data() {
        return {
            list: [],
        };
    },
    created() {
        let vm = this;
        vm.getData();
    },
    methods: {
        getData() {
            let vm = this;
            ajaxData("/news", {}).then((response) => {
                console.log(response);
                response.data?.list.forEach(val=>{
                    console.log(val,localStorage.getItem("locale") == 'en')
                    if (localStorage.getItem("locale") == "en") {
                        val.title = val.title_en;
                        val.content = val.content_en;
                        val.synopsis = val.synopsis_en;
                    }
                })
                vm.list = response.data.list;

            });
        },
        goHome() {
            this.$router.go(-1);
        },
        getDetail(id) {
            this.$router.push({ path: "/GongDetail?id=" + id });
        },
        handleBack() {
            const homeIndex = localStorage.getItem("homeIndex");
            if (homeIndex == 1) {
                localStorage.setItem("showMenu", 1);
            }
            this.$router.go(-1);
        },
    },
};
</script>

<style scoped lang="less">
p {
    margin: 0;
    padding: 0;
}
.gone {
    display: flex;
    flex-direction: row;
    align-items: center;
}

.proposeList {
    width: 100%;
    min-height: 100vh;
    background: #fff;
    padding: 30px 15px;
    background-image: linear-gradient(to bottom, #fff, #ccc);
    .dlogo {
        width: 31px;
        height: 31px;
        margin-right: 3px;
    }
    .gname {
        font-weight: bold;
        font-size: 20px;
        color: #000000;
    }
    .gtwo {
        display: flex;
        flex-direction: row;
        margin: 25px 0 20px;
        .gleft {
            flex: 1;
            background: #ededed;
            border-radius: 10px;
            padding: 10px 15px;
            display: flex;
            flex-direction: row;
            align-items: center;
            .img_tb {
                width: 15px;
                height: 15px;
                margin-right: 9px;
            }
            .gmiao {
                font-weight: 500;
                font-size: 14px;
                color: #999999;
            }
        }
        .gright {
            width: 40px;
            height: 40px;
            display: flex;
            margin-left: 10px;
            align-items: center;
            justify-content: center;
            background: #ededed;
            border-radius: 10px;
            .icon_ss {
                width: 16px;
                height: 16px;
            }
        }
    }
    .gnlist {
        display: flex;
        flex-direction: column;
        margin-bottom: 20px;
        .gntit {
            display: flex;
            flex-direction: row;
            align-items: center;
            .gbt {
                font-weight: bold;
                font-size: 16px;
                color: #000000;
            }
        }
    }
    .biconthree {
        width: 20px;
        height: 18px;
        margin-right: 5px;
    }
    .gnnav {
        padding: 10px 15px;
        background: #ffffff;
        border-radius: 10px;
        border: 0.5px solid #000000;
        margin-top: 10px;
        .ntit {
            font-weight: 500;
            font-size: 24rpx;
            color: #999999;
        }

        .ncha {
            display: flex;
            flex-direction: row;
            align-items: center;
            margin-top: 7px;
            .icon_sj {
                width: 10px;
                height: 10px;
                margin-right: 3px;
            }
            .chatime {
                font-weight: 500;
                font-size: 10px;
                color: #999999;
            }
            .cname {
                margin-left: auto;
                font-family: PingFang SC;
                font-weight: 500;
                font-size: 10px;
                color: #999999;
            }
        }
    }

    .header {
        height: 50px;
        // margin-bottom: 12px;
        // padding: 40px 12px 0 12px;
        padding: 6px;
        box-sizing: border-box;
        background: rgba(52, 56, 75, 1);
        display: flex;
        align-items: center;
        justify-content: center;
        position: sticky;
        width: 100%;
        z-index: 10;
        top: 0;
        img {
            width: 55px;
            height: 55px;
            position: absolute;
            left: 10px;
        }

        span {
            font-weight: bold;
            font-size: 18px;
            color: #ffffff;
        }
    }

    .mhead {
        // position: relative;
        // top: 50px;
    }
}
</style>
